"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var If_1 = require("../../hoc/If");
var Input_1 = require("../_forms/Input");
var Button_1 = require("../Button");
var enums_1 = require("../../enums");
var IconSymbols_1 = require("../../generated/IconSymbols");
var SearchButton = function (props) {
    var _a = React.useState(false), isSearchMode = _a[0], setIsSearchMode = _a[1];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "search-button ".concat(props.className || "") }, { children: [(0, jsx_runtime_1.jsxs)(If_1.IF, __assign({ condition: isSearchMode }, { children: [(0, jsx_runtime_1.jsx)(Input_1.Input, { id: "".concat(props.id, "Input"), borderStyle: "underline", value: props.value, placeholder: props.placeholder, onChange: props.onChange, autoFocus: true, onBlur: function () {
                            if (!props.value) {
                                setIsSearchMode(false);
                                props.onClose();
                            }
                        } }), (0, jsx_runtime_1.jsx)(Button_1.ButtonIcon, { symbol: IconSymbols_1.IconSymbols.Close, type: Button_1.ButtonTypes.LINK, id: "".concat(props.id, "CloseButton"), iconSize: enums_1.UiSizes.SM, className: "search-button__button--close", onClick: function () {
                            setIsSearchMode(false);
                            props.onClose();
                        } })] })), (0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: !isSearchMode }, { children: (0, jsx_runtime_1.jsx)(Button_1.ButtonIcon, { id: "".concat(props.id, "SearchButton"), symbol: IconSymbols_1.IconSymbols.Search, iconSize: enums_1.UiSizes.MD, type: props.buttonType || "outline-primary", onClick: function () {
                        setIsSearchMode(true);
                    } }) }))] })));
};
exports.SearchButton = SearchButton;
